import { WhoWillReceiveCareStep } from "#/components/carrot-card-cost-share/steps/views/WhoWillReceiveCareStep"
import { WhatKindGenderAffirmingCareStep } from "#/components/carrot-card-cost-share/steps/views/WhatKindGenderAffirmingCareStep"
import { PleaseConfirmOneThingStep } from "#/components/carrot-card-cost-share/steps/views/PleaseConfirmOneThingStep"
import {
  GenderAffirmingCareSteps,
  GeneralSteps,
  SectionName
} from "#/components/carrot-card-cost-share/workflows/step-library"
import { JourneySubTypeValues } from "#/components/carrot-card-cost-share/steps/shared/stepOptionValues"
import { PleaseConfirmTwoThingsStep } from "#/components/carrot-card-cost-share/steps/views/PleaseConfirmTwoThingsStep"
import { ExpenseNotCoveredStep } from "#/components/carrot-card-cost-share/steps/views/ExpenseNotCoveredStep"

export enum Workflows {
  GENDER_AFFIRMING_CARE = "Gender Affirming Care"
}

export const genderAffirmingCareSteps = [
  { name: GenderAffirmingCareSteps.WHO_WILL_RECEIVE_CARE_GAC, component: WhoWillReceiveCareStep },
  { name: GenderAffirmingCareSteps.WHAT_KIND_GENDER_AFFIRMING_CARE, component: WhatKindGenderAffirmingCareStep },
  { name: GenderAffirmingCareSteps.PLEASE_CONFIRM_ONE_THING, component: PleaseConfirmOneThingStep },
  { name: GenderAffirmingCareSteps.PLEASE_CONFIRM_TWO_THINGS, component: PleaseConfirmTwoThingsStep },
  { name: GenderAffirmingCareSteps.EXPENSE_NOT_COVERED_GAC, component: ExpenseNotCoveredStep }
]

//prettier-ignore
const genderAffirmingCareFlow: GenderAffirmingCareFlowTransition[] = [
  { at: GenderAffirmingCareSteps.WHO_WILL_RECEIVE_CARE_GAC,        given: "ELIGIBLE",                              goto: GenderAffirmingCareSteps.WHAT_KIND_GENDER_AFFIRMING_CARE },
  { at: GenderAffirmingCareSteps.WHO_WILL_RECEIVE_CARE_GAC,        given: "INELIGIBLE",                            goto: GenderAffirmingCareSteps.EXPENSE_NOT_COVERED_GAC },
  { at: GenderAffirmingCareSteps.WHAT_KIND_GENDER_AFFIRMING_CARE,  given: JourneySubTypeValues.BINDERS_OR_PACKERS, goto: GenderAffirmingCareSteps.PLEASE_CONFIRM_ONE_THING },
  { at: GenderAffirmingCareSteps.WHAT_KIND_GENDER_AFFIRMING_CARE,  given: "",                                      goto: GenderAffirmingCareSteps.PLEASE_CONFIRM_TWO_THINGS },
  { at: GenderAffirmingCareSteps.PLEASE_CONFIRM_ONE_THING,         given: "",                                      goto: GeneralSteps.TOTAL_COST, sectionName: SectionName.GENERAL },
  { at: GenderAffirmingCareSteps.PLEASE_CONFIRM_TWO_THINGS,        given: "",                                      goto: GeneralSteps.TOTAL_COST, sectionName: SectionName.GENERAL },
  { at: GenderAffirmingCareSteps.EXPENSE_NOT_COVERED_GAC,          given: "",                                      end: true }
]

type GenderAffirmingCareFlowTransition =
  | { at: GenderAffirmingCareSteps; given: string; goto: GenderAffirmingCareSteps; sectionName?: undefined }
  | { at: GenderAffirmingCareSteps; given: string; goto: GeneralSteps; sectionName: string }
  | { at: GenderAffirmingCareSteps; given: string; end: true }

export const genderAffirmingCareWorkflows = [
  { name: Workflows.GENDER_AFFIRMING_CARE, workflow: genderAffirmingCareFlow }
]
